import { Component, Inject, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { OrderService } from 'src/app/order.service';
import { Constants } from 'src/app/constants';
import { MyErrorStateMatcher } from '../instruction/instruction.component';
import { AnalyticsService } from 'src/app/_services/analytics.service';
import { DEVICE_TOKEN_KEY } from 'src/app/_helpers/auth.interceptor';


@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserLoginComponent implements OnInit {

  phoneNumber: string;
  otpSent: boolean = false;
  isOtpSending: boolean = false;
  otp: number;
  errorMatcher = new MyErrorStateMatcher();


  constructor(private orderService: OrderService,
    public dialogRef: MatDialogRef<UserLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private analyticsService: AnalyticsService,
  ) {

  }

  ngOnInit() {

  }

  getPlainPhoneNumberFromString(phoneNumber: string) {
    let ph = phoneNumber.replace(/[\s()-]/g, '')
    return '+1' + ph.substring(0, 10)
  }

  updatePhoneNumber(phoneNumber: string) {
    this.phoneNumber = phoneNumber;
    if(this.otpSent || this.isOtpSending) return;
    if (this.getPlainPhoneNumberFromString(phoneNumber).length === 12) {
      let plainPhoneNumber = this.getPlainPhoneNumberFromString(phoneNumber);
      const phone_number_check = plainPhoneNumber.replace(/\+/g, '');
      this.isOtpSending = true;
      this.orderService.checkNumberBlocked(this.data.store, phone_number_check).subscribe((data: any) => {
        if (data.data == false) {
          this.orderService.otpForOffer(this.data.store, null, plainPhoneNumber, true).subscribe(() => {
            this.otpSent = true;
            this.isOtpSending = false;
            this.cdr.markForCheck();
          })
        } else {
          this.isOtpSending = false;
          this.snackBar.open('Your phone number is blocked', "OK", {
            verticalPosition: 'top'
          })
        }
      }, () => {
        this.isOtpSending = false;
      });

    }
  }

  getPlainPhoneNumber() {
    if (this.phoneNumber) {
      let ph = this.phoneNumber.replace(/[\s()-]/g, '')
      return '+1' + ph.substring(0, 10)
    }
    return "";
  }

  cancel() {
    this.dialogRef.close(false);
  }

  verifyOTP() {
    this.orderService.verifyOtpForOffer(this.data.store, null, this.getPlainPhoneNumber(), this.otp, true).subscribe((data: any) => {
      // A wrong code comes back as 200 with an empty body. Keep the dialog open so the guest can
      // retype it, rather than closing as if they had logged in.
      if (!data || !data.is_verified) {
        this.snackBar.open('That code is incorrect. Please check it and try again.', 'OK',
          { duration: 4000, verticalPosition: 'top' });
        this.cdr.markForCheck();
        return;
      }
      localStorage.setItem(Constants.PHONE_NUMBER_KEY, this.getPlainPhoneNumber())
      // ENG-5610: the proof the account pages (wallet, loyalty, history) are gated on.
      if (data.device_token) {
        try {
          localStorage.setItem(DEVICE_TOKEN_KEY, data.device_token);
        } catch (e) {
          // storage blocked: the guest verifies again next time, nothing breaks
        }
      }
      this.analyticsService.identifyUser(data.phone_hash, this.getPlainPhoneNumber());
      this.analyticsService.trackEvent('login', { method: 'phone_otp' });
      this.dialogRef.close(data.phone_hash);
    }, (error) => {
      if(error.status === 403){
        this.snackBar.open('Your phone number is blocked', 'OK', { verticalPosition: 'top' });
      } else {
        this.snackBar.open('Verification failed. Please try again.', 'OK', { verticalPosition: 'top' });
      }
      this.dialogRef.close(false);
    })
  }
}
